import React from "react";
import { AspectRatio, Box, Flex } from "@chakra-ui/react";
import { DecorativeBackgroundImage } from "components/images";
import { Section, sectionSpacingY } from "components/section";
import { TextTitle } from "ui/text";
import { type StaticImageData } from "next/image";
import { useCdpIndustry } from "contexts/cdp-industry-context";
import Balancer from "react-wrap-balancer";
import auraBgRed from "../../../../public/assets/cdp-industries/aura-bgs/red.png";
import auraBgYellow from "../../../../public/assets/cdp-industries/aura-bgs/yellow.png";
import auraBgGreen from "../../../../public/assets/cdp-industries/aura-bgs/green.png";
import auraBgBlue from "../../../../public/assets/cdp-industries/aura-bgs/blue.png";
import auraBgViolet from "../../../../public/assets/cdp-industries/aura-bgs/violet.png";
import { OutcomeChip } from "./outcome-chip";

export function CdpIndustryBusinessOutcomes() {
  const { industry } = useCdpIndustry();

  const outcome1 = industry.featuredOutcomes[0];
  const outcome2 = industry.featuredOutcomes[1];
  const outcome3 = industry.featuredOutcomes[2];

  let auraBg: StaticImageData;

  switch (industry.color) {
    case "red": {
      auraBg = auraBgRed;
      break;
    }

    case "yellow": {
      auraBg = auraBgYellow;
      break;
    }

    case "green": {
      auraBg = auraBgGreen;
      break;
    }

    case "blue": {
      auraBg = auraBgBlue;
      break;
    }

    case "violet": {
      auraBg = auraBgViolet;
      break;
    }

    // No default
  }

  return (
    <Section my="0" py={sectionSpacingY}>
      <Flex flexDir={{ base: "column", lg: "row" }} alignItems="center" gap={{ base: "biggest", lg: "huge" }}>
        <TextTitle
          size="lg"
          title={<Balancer>Why are {industry.pluralNoun} adopting CDPs?</Balancer>}
          description={industry.adoptingCdpsDescription}
        />

        <AspectRatio ratio={1 / 1} boxSize="100%" maxW={{ base: "mediaMaxW.mobile", lg: "480px" }}>
          <Box pos="relative">
            <DecorativeBackgroundImage src={auraBg} />

            <Flex pos="relative" flexDir="column" w="100%" gap="34px" p={{ base: "big", sm: "bigger" }}>
              <OutcomeChip alignSelf="center" ml="huge" {...outcome1} />
              <OutcomeChip alignSelf="flex-start" ml="smaller" {...outcome2} />
              <OutcomeChip alignSelf="center" ml="huge" {...outcome3} />
            </Flex>
          </Box>
        </AspectRatio>
      </Flex>
    </Section>
  );
}
